module.exports = {
  projectId: 'rdtA7T',
  recordKey: 'yE6aGIoy6qrKeHPB'
}
